export default function (value) {
  const safeValue = value.replace(/[\s\(\)\[\]]+/, "");
  const regexp = /^\+[0-9 ]+$/;

  return regexp.test(String(safeValue).toLowerCase());
};
